const angular = require('angular')
const loginCtrl = require('js/login/loginCtrl')
const forgetPasswordCtrl = require('./forgetPasswordCtrl')
const forgetPasswordService = require('./forgetPasswordService')

module.exports = angular.module('hxphone.login', ['hxphone.services'])
  .controller('LoginCtrl', loginCtrl)
  .controller('forgetPasswordCtrl', forgetPasswordCtrl)
  .factory('forgetPasswordService', forgetPasswordService)



// WEBPACK FOOTER //
// ./src/js/login/module.js